export default {
  computed: {
    buttonText () {
      if (this.isVariationGroupMaster && this.isListing) {
        return `<img src="/ui/main/img/cart-icon.svg" alt="cart" class="cart-icon" width="50px" height="50px">`
      }

      if (this.isUnderContactLenses && !this.available) {
        return this.t('product_status.unavailable.contact.lenses')
      }

      if (!this.available && !this.cartLimitReached) {
        return this.t('product_status.unavailable.coming_soon')
      }

      if (!this.available && this.hasAttributes && !this.selectedAttributeId) {
        return this.t('product_status.unavailable.choose_attr')
      }

      if (!this.onlineStatus) {
        return `<i class="icon-energy icons"></i>${this.t('online_status.offline')}`
      }

      if (this.showAddToCartBtnText) {
        return `<img src="/ui/main/img/cart-icon.svg" alt="cart" class="cart-icon" width="50px" height="50px"><span>${this.t('add_to_cart')}</span>`
      }

      if (this.showAddToCartComboBtnText) {
        return `<img src="/ui/main/img/cart-icon.svg" alt="cart" class="cart-icon" width="50px" height="50px"><span>${this.t('add.to.cart.combo.button.text')}</span>`
      }

      return `<img src="/ui/main/img/cart-icon.svg" alt="cart" class="cart-icon" width="50px" height="50px">`
    },
    disabled () {
      return this.quantity < 1 || !this.onlineStatus || !this.available || this.progress || this.cartLimitReached || this.isProductInAvailabilityDate
    },
    available () {
      return this.stock > 0 && !this.unavailable
    },
    isProductInAvailabilityDate () {
      const { availableFrom, availableUntil } = this.productData
      if (availableFrom || availableUntil) {
        const currentDate = Date.now()
        return (
          (availableFrom != null && currentDate < new Date(availableFrom).getTime()) ||
          (availableUntil != null && currentDate > new Date(availableUntil).getTime())
        )
      }
      return false
    }
  }
}
